
var ua =  navigator.userAgent,
    isWechat = /MicroMessenger/i.test(ua),
    isAndroid = /Android/i.test(ua),
    isBlackBerry = /BlackBerry/i.test(ua),
    isWindowPhone = /IEMobile/i.test(ua),
    isIOS = /iPhone|iPad|iPod/i.test(ua),
    isMobile = isAndroid || isBlackBerry || isWindowPhone || isIOS;

function deviceType() {
    if(isIOS){
        return 'iphone';
    }else if(isAndroid){
        return 'android';
    }else{
        return 'web';
    }
}
function weChat() {
    if(isWechat){
        return true;
    }else{
        return false;
    }
}
export {
    deviceType,weChat
}



// WEBPACK FOOTER //
// ./src/assets/js/device.js